import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faStar } from "@fortawesome/free-solid-svg-icons";
import {
  convertMonthsToReadableFormat,
  getInitialsImage,
} from "src/helpers/helperFunctions";
import CartIcon from "src/assets/images/website-images/calendar-date.png";
import { IconButton } from "@mui/material";
import IconFav from "src/assets/images/heart-favorite.png";
import AddCartButton from "src/Components/GlobalComponents/AddCartButton";
import { useNavigate } from "react-router-dom";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";

interface Doctor {
  id: string;
  name: string;
  specialty: string;
  qualification: string;
  experience: string;
  reviews: number;
  rating: number;
  price: number;
  currency: string;
  image: string;
}

interface DoctorCardProps {
  doctor: Doctor;
  heart_id?: string;
  button_id?: string;
  onClose?: () => void;
  handleRemove: () => void;
}

const DoctorWhislistCard: React.FC<DoctorCardProps> = ({
  doctor,
  heart_id,
  button_id,
  onClose,
  handleRemove
}) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white rounded-[10px] border border-[#D5D5D5] shadow-[0px_0px_7px_#00000029] px-[6px] 2xl:px-2 py-2 2xl:py-3 flex gap-1 2xl:gap-2 items-center">
      {/* <IconButton onClick={() => {}} id={heart_id}>
        <img src={IconFav} alt="Fav" className="w-[17px] 2xl:w-[20px]" />
      </IconButton> */}
      <FavoriteCoponent
        category="doctor"
        onLikeProduct={handleRemove}
        id={doctor?.id}
        liked={true}
        className="bg-transparent"
        isWhishList
      />
      <div className="flex flex-col gap-2 2xl:gap-3 flex-1">
        <div className="flex gap-2 relative mb-1">
          <div className="max-w-[5vw] rounded-lg h-fit overflow-hidden">
            <img
              src={`${doctor.image || ""}`}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = getInitialsImage(doctor.name, 112, 48, "#00443f");
              }}
              alt={doctor.name}
              className="aspect-square"
            />
          </div>
          <div className="w-full height-issue-resolve-find-doctor flex flex-col gap-1">
            <h3 className="font-size-20px font-Montserrat-SemiBold  capitalize flex flex-row gap-1 items-center whishlist-dr-name-text-color">
              {doctor.name}
            </h3>
            <h6 className="font-size-16px flex flex-wrap text-[#202020] font-Poppins-Medium">
              <span className="line-clamp-1">
                {doctor.specialty
                  ?.split("|")
                  .slice(0, 4)
                  .map((v) => v.trim())
                  .map((v) => (v.length > 15 ? `${v.slice(0, 15)}...` : v))
                  .join(" | ")}
              </span>
            </h6>
            <p className="font-size-16px flex flex-wrap text-[#393939] font-Poppins-Regular">
              <span className="line-clamp-1">
                {doctor.qualification
                  ?.split(",")
                  .slice(0, 2)
                  .map((v) => v.trim())
                  .map((v) => (v.length > 15 ? `${v.slice(0, 15)}...` : v))
                  .join(", ")}
              </span>
            </p>
          </div>
        </div>
        <div className="find-doctor-car-experience flex gap-4">
          <div className="flex flex-col">
            <span className="font-size-14px text-[#707070] font-Poppins-Regular">
              Experience
            </span>
            <span className="font-size-16px text-[#2A2A2A] font-Poppins-Medium doctor-experience-text-color">
              {convertMonthsToReadableFormat(Number(doctor.experience) || 0)}
            </span>
          </div>
          <p style={{ border: "0.2px solid rgb(131 126 126 / 21%)" }}></p>
          <div className="flex flex-col gap-1">
            <span className="font-size-16px text-[#707070] font-Poppins-Regular">
              Reviews
            </span>
            <span className="font-size-15px text-[#2A2A2A] font-Poppins-Medium doctor-reviews-text-color">
              {doctor.reviews}
            </span>
          </div>
          <p style={{ border: "0.2px solid rgb(131 126 126 / 21%)" }}></p>
          <div className="flex flex-col gap-1">
            <span className="font-size-15px text-[#707070] font-Poppins-Regular">
              Rating
            </span>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((v) => (
                <FontAwesomeIcon
                  key={v}
                  className={`font-size-16px ${
                    doctor.rating >= v ? "text-[#FF9B29]" : "text-[#707070]"
                  }`}
                  icon={faStar}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <p className="font-size-16px text-[#202020] font-Poppins-Medium">
            <span className="font-size-18px font-Poppins-SemiBold  doctor-price-text-color">
              {doctor.currency} {doctor.price.toLocaleString() || "-"}
            </span>
          </p>
          <AddCartButton
            icon="Calender"
            onClick={() => {
              onClose?.();
              navigate(`/doctor-public-profile/${doctor?.id}/view`);
            }}
            id={button_id}
            type="doctor"
            title="Book Appointment"
          />
        </div>
      </div>
    </div>
  );
};

export default DoctorWhislistCard;
